import { render, staticRenderFns } from "./deneme.vue?vue&type=template&id=77c23ab3&"
import script from "./deneme.vue?vue&type=script&lang=js&"
export * from "./deneme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports